module.exports = __webpack_public_path__ + "img/1.1_Russian_road_sign.62520705.svg";